document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.upsell__container').forEach(function (upsell) {
    const dropdown     = upsell.querySelector('select.variant-dropdown');
    const form         = upsell.querySelector('form[data-type="add-to-cart-form"]');
    const addBtn       = upsell.querySelector('.upsell__plus-btn');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;

    // Keep variant ID in sync when dropdown changes
    if (dropdown && variantInput) {
      dropdown.addEventListener('change', function () {
        const variants = getVariants(upsell);
        const match = variants.find(v => v.title === dropdown.value);
        if (match) variantInput.value = match.id;
      });
    }

    if (addBtn && variantInput) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.classList.contains('upsell--added')) return; // prevent double-click

        const variantId = parseInt(variantInput.value);
        if (!variantId) return;

        // Add to cart via fetch
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to add to cart');
          return res.json();
        })
        .then(function () {
          // 1. Mark button as added (swap add icon -> check icon)
          addBtn.classList.add('upsell--added');
          const unchecked = addBtn.querySelector('.checkmark-unchecked');
          const checked   = addBtn.querySelector('.checkmark-checked');
          if (unchecked) unchecked.style.display = 'none';
          if (checked)   checked.style.display   = 'inline';

          // 2. Re-render cart drawer using Shrine's Section Rendering API
          const sections = ['cart-drawer', 'cart-icon-bubble'];
          fetch(`/?sections=${sections.join(',')}`)
            .then(r => r.json())
            .then(function (sectionsData) {

              // Update cart drawer contents
              const cartDrawerEl = document.querySelector('cart-drawer');
              if (cartDrawerEl && sectionsData['cart-drawer']) {
                const parsed = new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html');
                const newInner = parsed.querySelector('cart-drawer');
                if (newInner) {
                  cartDrawerEl.innerHTML = newInner.innerHTML;
                  cartDrawerEl.classList.remove('is-empty');
                }
              }

              // Update cart icon bubble (item count in header)
              const bubbleEl = document.getElementById('cart-icon-bubble');
              if (bubbleEl && sectionsData['cart-icon-bubble']) {
                const parsed = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
                const newBubble = parsed.getElementById('cart-icon-bubble');
                if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
              }

              // 3. Open the cart drawer
              openCartDrawer();
            });
        })
        .catch(function (err) {
          console.error('Upsell add to cart error:', err);
        });
      });
    }
  });

  function openCartDrawer() {
    // Shrine theme cart drawer — try multiple methods in order
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Method 1: Shrine's built-in open attribute
    cartDrawer.setAttribute('open', '');
    cartDrawer.classList.remove('is-empty');

    // Method 2: click the cart icon as fallback to trigger theme's own open logic
    const cartToggle = document.querySelector('[href="#cart-drawer"], .cart-drawer__toggle, #cart-icon-bubble, [data-cart-toggle]');
    if (cartToggle && !cartDrawer.hasAttribute('open')) {
      cartToggle.click();
    }
  }

  function getVariants(upsell) {
    const script = upsell.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); }
    catch (e) { return []; }
  }

});
